var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.visible)?_c('div',{class:'dialog-tips' + ' dialog-' + _vm.type},[_c('div',[_c('i',{staticClass:"iconfont icon-xiaoxi"}),_vm._v(" "+_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }